<template>
<div class="my-dialog">
    <Modal v-model="show" :width="width" :loading="loading" :className="className" :scrollable="scrollable" :maskClosable="maskClosable" @on-cancel="cancel" @on-visible-change="vchange" :transfer="transfer">
        <Spin fix v-if="loading">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="d-tit" slot="header">
            <h3>{{title}}</h3>
            <p class="sub-tit" v-if="subTit">{{subTit}}</p>
        </div>
        <slot></slot>
        <div slot="footer">
            <Button v-if="okBtn" type="primary" :loading="loading" @click="ok" size="large">{{okText}}</Button>
            <Button v-if="cancelBtn" type="text" @click="cancel" size="large">{{cancelText}}</Button>
        </div>
    </Modal>
</div>
</template>

<script>
    export default {
        name:'dialogHr',
        props:{
            title:{
                type:String,
                default:null
            },
            subTit:{
                type:String,
                default:null
            },
            transfer:{
                type:Boolean,
                default:true
            },
            okText:{
                type:String,
                default:'确定'
            },
            cancelText:{
                type:String,
                default:'取消'
            },
            okBtn:{
                type:Boolean,
                default:true
            },
            cancelBtn:{
                type:Boolean,
                default:false
            },
            loading:{
                type:Boolean,
                default:false
            },
            width:{
                type:Number,
                default:520
            },
            className:{
                type:String,
                default:null
            },
            maskClosable:{
                type:Boolean,
                default:false
            },
            scrollable:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                show:true
            }
        },
        methods:{
            cancel(){
                this.show = false;
                this.$emit('cancel');
            },
            ok(){
                this.$emit('ok');
            },
            vchange(v){
                if(!v){
                    this.cancel();
                };
            }
        },
        watch:{
            show(){
                this.$emit('input', this.show);
            }
        },
        created(){
            //console.log(this.show,'ccc');
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .d-tit {
        h3 {
            font-size:18px;
            color:#393a41;
        }
        .sub-tit {
            font-size:14px;
            color: #80848E;
            font-weight:normal;
            line-height: 36px;
            height:36px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/myDialog.vue